"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var core_1 = require("@athena-portal/core");
var Types_1 = require("../../../Types");
var components_1 = require("@athena-portal/components");
var Confirmation_1 = require("../../Confirmation");
var Tree_1 = require("../../../components/Tree");
var SuppressRenewalAction = /** @class */ (function (_super) {
    __extends(SuppressRenewalAction, _super);
    function SuppressRenewalAction(props) {
        var _this = _super.call(this, props) || this;
        _this.updateSuppressRenewalFlag = function () {
            _this.supportPortalService
                .setSuppressRenewalFlag(_this.props.customerReferenceNumber, _this.props.policyNumber, !_this.state.suppressRenewalflag)
                .subscribe(function (response) {
                if (!(response instanceof Error)) {
                    _this.setState({
                        suppressRenewalflag: !_this.state.suppressRenewalflag
                    });
                }
            });
            _this.supportPortalService.logAgentActivity(_this.props.customerReferenceNumber, { "action": "Suppress Renewal Communications: ".concat(!_this.state.suppressRenewalflag), "customer": _this.props.policyNumber }).subscribe();
            _this.setState({ showConfirmation: false });
        };
        _this.state = {
            showConfirmation: false,
            suppressRenewalflag: _this.props.suppressRenewal
        };
        return _this;
    }
    SuppressRenewalAction.prototype.render = function () {
        var _this = this;
        var linkText = this.state.suppressRenewalflag
            ? 'Switch on renewal communications'
            : 'Suppress Renewal Communications';
        return ((0, jsx_runtime_1.jsx)(Tree_1.Tree, { label: (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("a", { className: "d-block text-primary on-hover-underline", onClick: function () { return _this.setState({ showConfirmation: true }); }, children: linkText }), (0, jsx_runtime_1.jsx)(Confirmation_1.default, { show: this.state.showConfirmation && !this.state.suppressRenewalflag, hide: function () { return _this.setState({ showConfirmation: false }); }, confirm: function () { return _this.updateSuppressRenewalFlag(); }, confirmBtnText: "Yes", title: "Suppress Renewal Communications", message: "Are you sure you want to suppress renewal communications for this policy? " }), (0, jsx_runtime_1.jsx)(Confirmation_1.default, { show: this.state.showConfirmation && this.state.suppressRenewalflag, hide: function () { return _this.setState({ showConfirmation: false }); }, confirm: function () { return _this.updateSuppressRenewalFlag(); }, confirmBtnText: "Yes", title: "Switch on renewal communications", children: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("h5", { className: "font-weight-bold", children: "Documents:" }), (0, jsx_runtime_1.jsx)("p", { children: "- Renewal invite cover letter and important updates" }), (0, jsx_runtime_1.jsx)("h5", { className: "font-weight-bold", children: "Communications:" }), (0, jsx_runtime_1.jsx)("p", { children: "- Renewal Communications" })] }) })] }) }));
    };
    __decorate([
        (0, core_1.lazyInject)(Types_1.Types.SupportPortalService),
        __metadata("design:type", Object)
    ], SuppressRenewalAction.prototype, "supportPortalService", void 0);
    SuppressRenewalAction = __decorate([
        components_1.authorize,
        (0, components_1.role)("Administrator", "CSR_Lead", "CSR", "Support"),
        __metadata("design:paramtypes", [Object])
    ], SuppressRenewalAction);
    return SuppressRenewalAction;
}(React.Component));
exports.default = SuppressRenewalAction;
//# sourceMappingURL=SuppressRenewalAction.js.map